import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/reckncase/timeline-back.webp";

const Timecmore = () => {
  return (
    <div
      className="time_milo p-100 text_reck"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      <Container>
        <Row>
          <div className="time_head text-center">
            <h2>
              Project <span>Timeline</span>
            </h2>
          </div>
        </Row>

        <Col
          xs={12}
          md={12}
          lg={12}
          xl={12}
          xxl={12}
          className="text-center mt-3"
        >
          <div className="timeline_img">
            <StaticImage
              src="../../../images/case-studies/reckncase/timline_img.webp"
              alt="TekRevol"
              className="img-fluid"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1259}
              height={600}
            />
          </div>
        </Col>
      </Container>
    </div>
  );
};

export default Timecmore;
